import {Card, CardBody, CardFooter, CardHeader, Divider, Flex, Image, Tag, TagLeftIcon, Text} from "@chakra-ui/react";
import {Icon, RepeatClockIcon} from "@chakra-ui/icons";
import dayjs from "dayjs";
import {FaClock, FaTag} from "react-icons/fa";
import React from "react";
import OrderCard from "../../components/OrderCard/OrderCard";

export default ({orders} : {orders: any[]}) => {
    return <Flex flexWrap={'wrap'} p={3} gap={3} w={'full'}>{orders.map(order => <OrderCard order={order}/> )}</Flex>
}